import { useState, useEffect } from 'react';
import { getEmitter } from '@laigu/utils';

const emitter = getEmitter();

const useWindowState = (key, defaultValue) => {
  const getStoredValue = () => window[key];

  const [state, setState] = useState(() => (window[key] !== undefined ? window[key] : defaultValue));
  const emitKey = `windowState_${key}`;

  const handleUpdateState = params => {
    window[key] = params;
    setState(params);
  };

  const updateState = param => {
    emitter.emit(emitKey, param);
  };

  useEffect(() => {
    const storedValue = getStoredValue(key);
    if (storedValue !== null && storedValue !== undefined) {
      setState(storedValue);
    }
  }, [key]);

  useEffect(() => {
    emitter.on(emitKey, handleUpdateState);
    return () => {
      emitter.off(emitKey, handleUpdateState);
    };
  }, []);

  return [state, updateState];
};

export default useWindowState;
